import _ from 'underscore';

import {requestSchemaToFulfillmentType} from 'requests/fulfillments/FulfillmentType';
import {Request, RequestSchema} from 'requests/RequestConstants';

function hasExecutePermissionOnRequests(requests: Array<Request>): boolean {
  return requests.every((request: Request) => request.permissions.canExecuteRequest);
}

function doRequestsHaveNeededSamples(
  requests: Array<Request>,
  requestSchemaByRequestId: {[id: string]: RequestSchema},
  requestIdToRequestHasSamples: {[requestId: string]: boolean}
): boolean {
  if (_.isEmpty(requestSchemaByRequestId)) {
    return false;
  }
  return requests.every((request: Request) => {
    const sampleGroupSchema = requestSchemaByRequestId[request.id].sampleGroupSchema;
    return !sampleGroupSchema || (sampleGroupSchema && Boolean(requestIdToRequestHasSamples[request.id]));
  });
}

/**
 *  Requests are compatible if they have the same fulfillment type.
 */
function areSelectedRequestsCompatible(
  requests: Array<Request>,
  requestSchemaByRequestId: {[id: string]: RequestSchema}
): boolean {
  const fulfillmentTypes = requests.map(({id}) =>
    requestSchemaToFulfillmentType(requestSchemaByRequestId[id])
  );
  return fulfillmentTypes.every((type) => type === fulfillmentTypes[0]);
}

export default function canRequestsBeExecuted({
  requests,
  requestSchemaByRequestId,
  requestIdToRequestHasSamples,
}: {
  requests: Array<Request>;
  requestSchemaByRequestId: {[requestId: string]: RequestSchema};
  requestIdToRequestHasSamples: {[requestId: string]: boolean};
}): {explanationMessage: string | null; executeEnabled: boolean} {
  if (requests.length === 0) {
    return {
      executeEnabled: false,
      explanationMessage: 'Select a request to execute',
    };
  } else if (!hasExecutePermissionOnRequests(requests)) {
    return {
      executeEnabled: false,
      explanationMessage: 'Requires execute permission for all selected requests',
    };
  } else if (!doRequestsHaveNeededSamples(requests, requestSchemaByRequestId, requestIdToRequestHasSamples)) {
    return {
      executeEnabled: false,
      explanationMessage: 'No samples specified',
    };
  } else if (!areSelectedRequestsCompatible(requests, requestSchemaByRequestId)) {
    return {
      executeEnabled: false,
      explanationMessage: 'Cannot execute requests because sample types are mismatched',
    };
  }
  return {
    executeEnabled: true,
    explanationMessage: null,
  };
}
